module.exports = __webpack_public_path__ + "img/tablecloth.25be1600.png";